import React, { Component } from 'react'
import { connect } from 'react-redux'
import makeUrlFriendly from './../../lib/makeUrlFriendly'
import RepositoryEdit from './RepositoryEdit'
import { loadBranches, setSelectedBranch } from './../../store/repositories/actions'
import Loading from './../Loading'

const mapStateToProps = (state, props) => {
  var repo = getRepository(state.repositories, props.urlFriendlyRepoName)

  if (repo.selectedBranch){
    var branch = state.branches[repo.selectedBranch]
    if (branch.schema && state.uncommitted[branch.schema]){
      var thereAreUnsavedFilesOnTheSelectedBranch = true
    }
  }

  return {
    loading: state.loading[repo.id + '-branches'] !== false,
    repoId: repo.id,
    branchIds: repo.branches || [],
    selectedBranchId: repo.selectedBranch,
    // This is only so that we can default to master if its available
    masterBranchId: (repo.branches || []).find(branchId => {
      var branch = state.branches[branchId]
      return branch.name == 'master'
    }),
    thereAreUnsavedFilesOnTheSelectedBranch: !!thereAreUnsavedFilesOnTheSelectedBranch,
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadBranches: (repoId) => dispatch(loadBranches(repoId)),
  setSelectedBranch: (branchId, repoId) => dispatch(setSelectedBranch(branchId, repoId)),
})

class RepositoryEditContainer extends Component {

  shouldComponentUpdate = (next) => {
    var props = this.props

    return props.repoId != next.repoId ||
      JSON.stringify(next.branchIds) != JSON.stringify(props.branchIds) ||
      props.loading != next.loading ||
      props.selectedBranchId != next.selectedBranchId ||
      props.thereAreUnsavedFilesOnTheSelectedBranch != next.thereAreUnsavedFilesOnTheSelectedBranch
  }

  componentWillMount = () => {
    const { loadBranches, repoId } = this.props
    loadBranches(repoId)
  };

  componentWillReceiveProps = (newProps) => {

    var props = this.props

    // If we have branches but one isn't selected then select one by default
    if (newProps.branchIds.length > 0
      && !newProps.selectedBranchId){
      // Try and select master else default to the first branch
      newProps.setSelectedBranch(
        (newProps.masterBranchId || newProps.branchIds[0]),
        newProps.repoId,
      )
    }
  }

  onBranchSelect = (branchId) => {
    const { setSelectedBranch, repoId } = this.props
    setSelectedBranch(branchId, repoId)
  }

  render = () => {
    var props = this.props

    if (props.loading)
      return <Loading />

    return <RepositoryEdit
      branchIds={props.branchIds}
      selectedBranchId={props.selectedBranchId}
      onBranchSelect={this.onBranchSelect}
      repositoryId={props.repoId}
      thereAreUnsavedFilesOnTheSelectedBranch={props.thereAreUnsavedFilesOnTheSelectedBranch}
    />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RepositoryEditContainer)

/**
 * Iterates over all the repositories until its finds a match with
 * the url friendly repo name. Throws if one isn't found
 * @param {reposObj} object Where the key is the repo id and the value is the
 * repo object
 * @param {string} urlFriendlyRepoName
 * @return {string} the repo id
 */
function getRepository(reposObj, urlFriendlyRepoName){
  var id = Object.keys(reposObj).find(id => {
    var repo = reposObj[id]
    return makeUrlFriendly(repo.name) == urlFriendlyRepoName
  })
  if (!id)
    throw new Error(`Could not find matching repo ${urlFriendlyRepoName}`)
  return reposObj[id]
}


// WEBPACK FOOTER //
// ./src/pages/RepositoryEdit/Container.js